import { GATrackingEvent } from '../ga-tracking-event.model';
import { GATrackingEventPayload } from '../ga-tracking-event-payload.model';
import { Offer, Product } from '~app/modules/product/models';
import get from 'lodash.get';
import { PriceTypes } from '~shared/modules/price-type-toggler/models/price-types.enum';
import { Category } from '~app/modules/generic/models';
import {
  GaTrackingEventName,
  GATrackingEventType,
  GtmTemplateTypeEnum
} from '~shared/modules/ga-tracking/constants';
import { NUMBER_1 } from '~shared/constants';
import { GaTrackingHelpersService } from '../../utils/ga-tracking-helpers.service';

export class GATrackingViewItemEvent implements GATrackingEvent {

  constructor(
    private product: Product,
    private priceType: PriceTypes,
    private selectedOfferId?: string,
    private breadcrumbs?: Category[],
    private EECLabel?: string,
    private recommendation?: boolean,
    private previousUrl?: string,
    private isBlackDealsEnabled?: boolean

  ) { }

  getEventType(): GATrackingEventType {
    return GATrackingEventType.ViewItem;
  }

  getGtmDataLayerTemplateType() {
    return GtmTemplateTypeEnum.ProductDetail;
  }

  getGtmDataLayerTitle() {
    return get(this.product, 'name', '');
  }

  getSelectedOffer(): Offer {
    return (this.selectedOfferId) ?
      get(this.product.offers.filter(offer => offer.id === this.selectedOfferId), '[0]', this.product.bestOffer) :
      this.product.bestOffer;
  }

  getPayload(): GATrackingEventPayload {
    const offer = this.getSelectedOffer();
    return {
      event: GaTrackingEventName.ViewItem,
      gtmCustom: {
        ecommerce: {
          items: [{
            ...GaTrackingHelpersService.getItemObjectForGA4(
              this.product,
              offer,
              this.priceType,
              !!offer?.valueAddedServices?.length,
              this.breadcrumbs,
              this.recommendation,
              NUMBER_1,
              this.EECLabel,
              this.previousUrl,
              this.isBlackDealsEnabled
            )
          }]
        }
      }
    };
  }

}
